import { HeaderNames } from '@blk/aw-bff-typescript-models';
import { AxiosRequestConfig } from 'axios';
import { REQUEST_ID_HEADER } from '../APIConstants';

/**
 * Ideally, this class should live in aw-utils and should be using existing UUIDGenerator.UUID() to generate UUID.
 * But due to aw-utils having dependency on aw-api-clients, it would create cyclic dependency.
 * The aw-utils having dependency on aw-api-clients needs to be reviewed.
 */

export const DEFAULT_BEARER_AUTH_SCHEME = 'Bearer';

export const AUTHORIZATION_HEADER_ID: HeaderNames = 'Authorization';

export function setHeaderRequestId(config: AxiosRequestConfig) {
  if (config.headers?.[HeaderRequestId.NAME] === undefined) {
    config.headers = { ...config.headers, ...new HeaderRequestId().toHeader() };
  }
}

export class HeaderRequestId {
  public static readonly NAME = REQUEST_ID_HEADER;
  private id: string = UUID();

  getId(): string {
    return this.id;
  }

  toHeader(): { [key: string]: string } {
    return {
      [HeaderRequestId.NAME]: this.id,
    };
  }
}

// Currently this is equivalent to UUIDGenerator.UUID()
function UUID() {
  // http://www.ietf.org/rfc/rfc4122.txt
  let s: any[] = [];
  let hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  return s.join('');
}
